module.exports = __webpack_public_path__ + "img/login-v2.29f10254.svg";